import React, { useState } from 'react';
import { supabase } from '../../../lib/supabase';

const CommentForm = ({ postId, parentId = null, onSuccess, onCancel }) => {
  const [form, setForm] = useState({ author_name: '', author_email: '', content: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e?.target?.name]: e?.target?.value }));
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!form?.author_name?.trim() || !form?.author_email?.trim() || !form?.content?.trim()) {
      setError('Alle felt er påkrevd.');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const { error: insertError } = await supabase?.from('comments')?.insert({
        post_id: postId,
        parent_id: parentId,
        author_name: form?.author_name?.trim(),
        author_email: form?.author_email?.trim(),
        content: form?.content?.trim(),
        status: 'pending'
      });
      if (insertError) throw insertError;
      setSuccess(true);
      setForm({ author_name: '', author_email: '', content: '' });
      onSuccess?.();
    } catch (err) {
      setError(err?.message || 'Kunne ikke sende kommentar.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.12)',
    padding: '12px 16px',
    fontFamily: 'Inter, sans-serif',
    fontSize: '0.9rem',
    color: '#EEF0F2',
    outline: 'none',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s'
  };

  if (success) {
    return (
      <div style={{ background: 'rgba(46,196,160,0.08)', border: '1px solid rgba(46,196,160,0.3)', padding: '24px', marginTop: '16px' }}>
        <p style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, color: '#2EC4A0', fontSize: '0.875rem', letterSpacing: '0.1em', textTransform: 'uppercase', margin: '0 0 8px' }}>KOMMENTAR MOTTATT</p>
        <p style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', color: 'rgba(238,240,242,0.65)', fontSize: '0.875rem', margin: 0 }}>Din kommentar er sendt til moderering og vil vises etter godkjenning.</p>
        {onCancel && <button onClick={onCancel} style={{ marginTop: '12px', fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#3B6FD4', background: 'none', border: 'none', cursor: 'pointer', letterSpacing: '0.1em', textTransform: 'uppercase' }}>LUKK</button>}
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: '16px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
        <div>
          <label style={{ display: 'block', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.625rem', color: '#3B6FD4', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '6px' }}>NAVN *</label>
          <input
            name="author_name"
            value={form?.author_name}
            onChange={handleChange}
            placeholder="Ditt navn"
            style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#3B6FD4'}
            onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
          />
        </div>
        <div>
          <label style={{ display: 'block', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.625rem', color: '#3B6FD4', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '6px' }}>E-POST *</label>
          <input
            name="author_email"
            type="email"
            value={form?.author_email}
            onChange={handleChange}
            placeholder="din@epost.no"
            style={inputStyle}
            onFocus={e => e.target.style.borderColor = '#3B6FD4'}
            onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
          />
        </div>
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', fontFamily: 'JetBrains Mono, monospace', fontSize: '0.625rem', color: '#3B6FD4', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '6px' }}>KOMMENTAR *</label>
        <textarea
          name="content"
          value={form?.content}
          onChange={handleChange}
          placeholder="Skriv din kommentar her..."
          rows={4}
          style={{ ...inputStyle, resize: 'vertical', minHeight: '100px' }}
          onFocus={e => e.target.style.borderColor = '#3B6FD4'}
          onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
        />
      </div>
      {error && <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8rem', color: '#E76F51', marginBottom: '12px' }}>{error}</p>}
      <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
        <button
          type="submit"
          disabled={loading}
          style={{
            fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700,
            color: '#050A12', background: loading ? 'rgba(59,111,212,0.5)' : '#3B6FD4',
            border: 'none', padding: '12px 24px', cursor: loading ? 'not-allowed' : 'pointer',
            letterSpacing: '0.1em', textTransform: 'uppercase', transition: 'all 0.2s'
          }}
        >
          {loading ? 'SENDER...' : 'SEND KOMMENTAR'}
        </button>
        {onCancel && (
          <button type="button" onClick={onCancel} style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: 'rgba(238,240,242,0.4)', background: 'none', border: '1px solid rgba(255,255,255,0.1)', padding: '12px 20px', cursor: 'pointer', letterSpacing: '0.1em', textTransform: 'uppercase' }}>AVBRYT</button>
        )}
      </div>
      <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: 'rgba(238,240,242,0.3)', marginTop: '12px', fontStyle: 'italic' }}>E-postadressen din vil ikke vises offentlig. Kommentarer modereres før publisering.</p>
    </form>
  );
};

export default CommentForm;
